import React from "react";
import clsx from "clsx";

import Button from "@material-ui/core/Button";
import AddCircleOutlineIcon from "@material-ui/icons/AddCircleOutline";

import useStyles from "./styles";

interface IProps {
  isOptional?: boolean;
  disabled?: boolean;
  className?: string;
  title: string;
  onClick: () => void;
}

const AddEntryButton = (props: IProps) => {
  const {
    isOptional = false,
    disabled = false,
    title,
    onClick,
    className
  } = props;
  const classes = useStyles();

  return (
    <div>
      <Button
        className={clsx(className, classes.button)}
        disabled={disabled}
        startIcon={<AddCircleOutlineIcon />}
        onClick={onClick}
      >
        {title}
      </Button>
      {isOptional && <span className={classes.optional}>(optional)</span>}
    </div>
  );
};

export default AddEntryButton;
